import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';
export const CloseIcon = (props: IconPropsType) => {
  const {fill = '#43494F'} = props;
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.6663 10C16.6663 13.6819 13.6816 16.6667 9.99967 16.6667C6.31778 16.6667 3.33301 13.6819 3.33301 10C3.33301 6.31814 6.31778 3.33337 9.99967 3.33337C13.6816 3.33337 16.6663 6.31814 16.6663 10ZM13.03 6.96971C13.3229 7.2626 13.3229 7.73748 13.03 8.03037L11.0603 10L13.03 11.9697C13.3229 12.2626 13.3229 12.7375 13.03 13.0304C12.7371 13.3233 12.2622 13.3233 11.9693 13.0304L9.99967 11.0607L8.03 13.0304C7.73711 13.3233 7.26224 13.3233 6.96934 13.0304C6.67645 12.7375 6.67645 12.2626 6.96934 11.9697L8.93901 10L6.96934 8.03037C6.67645 7.73748 6.67645 7.2626 6.96934 6.96971C7.26224 6.67682 7.73711 6.67682 8.03 6.96971L9.99967 8.93938L11.9693 6.96971C12.2622 6.67682 12.7371 6.67682 13.03 6.96971Z'
        fill={fill}
      />
    </svg>
  );
};

CloseIcon.iconType = ICON_TYPES.CLOSE;
